import { createApp } from 'vue'
import './style.css'
import App from './App.vue'
import { router } from './router'
import 'simplebar/dist/simplebar.css'
import { registerShortcut } from './shortcutManager'
import './states/documentKeyPress'
import 'context-filter-polyfill';
import "toastify-js/src/toastify.css"

//custom variables
if(import.meta.env.VITE_TARGET === 'veles') {
  import("@/assets/custom/veles/variables.css");
} else if(import.meta.env.VITE_TARGET === 'msr') {
  import("@/assets/custom/msr/variables.css");
} else if(import.meta.env.VITE_TARGET === 'connect-msr') {
  import("@/assets/custom/msr/variables.css");
} else {
  import("@/assets/custom/main/variables.css");
}

registerShortcut()
const app = createApp(App)
app.use(router)
app.mount('#app')
